//import { mergeMap, tap } from 'rxjs/operators';
// RxJS
//import { delay, distinctUntilChanged, skip, filter, take, map } from 'rxjs/operators';
// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
// State
import { AppState } from '../../reducers';
import {
  selectFacilitiesPageLoading,
  selectFacilitiesShowInitWaitingMessage,
  selectFacilitiesInStore,
} from '../_selectors/facility.selectors';

export class FacilitiesDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectFacilitiesPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(select(selectFacilitiesShowInitWaitingMessage));

    this.store.pipe(select(selectFacilitiesInStore)).subscribe((response: QueryResultsModel) => {
      this.paginatorTotalSubject.next(response.totalCount);
      this.entitySubject.next(response.items);
    });
  }
}
